import Vue from 'vue'
import VueI18n from 'vue-i18n'
// I18n
import dateTimeFormats from '@/locales/dateTimeFormats'
import messages from '@/locales/messages'
import numberFormats from '@/locales/numberFormats'

// I18n
Vue.use(VueI18n)

export default new VueI18n({
  locale: 'pt-BR', // set locale en-US
  dateTimeFormats,
  messages,
  numberFormats
})



// WEBPACK FOOTER //
// ./src/plugins/i18n.js